import Grid from "@mui/material/Grid2";
import React from "react";

import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import { SubscribeMessages } from "@/messages/subscribe/subscribe.messages";

import Summary from "../Summary";

type Props = {
  messages: SubscribeMessages;
};

function SubscriptionSummary({ messages }: Props) {
  return (
    <MDBox sx={{ width: "100%" }}>
      <Grid size={12}>
        <Summary messages={messages} />

        <MDBox textAlign={"center"}>
          <MDTypography variant="body2">{messages.chargedEveryMonthLabel}</MDTypography>
        </MDBox>
      </Grid>
    </MDBox>
  );
}

export default SubscriptionSummary;
